import './mapComponent.scss'

import React from 'react';
import { withLocalize, Translate } from "react-localize-redux";
import { isNullOrUndefined } from '../../store/storeFunctions';
import GoogleLogo from '../../img/GoogleMaps_logo.svg';
import MapyCzLogo from '../../img/mapycz-logo.png';
import ReactTooltip from 'react-tooltip';

class Map extends React.Component {

    state = { renderTooltip: true }; // hack - renderTooltip state variable is used to ensure that
    // React Tooltip is rendered, then dismissed and then again rendered.
    // Otherwise a nonsense empty line in content is rendered.

    componentDidMount() {
        this.setState({ renderTooltip: false });
    }

    componentDidUpdate() {
        if (!this.state.renderTooltip) {
            this.setState({ renderTooltip: true });
        }
    }

    render() {

        if (this.props.address === undefined || this.props.address === null)
            return null;

        const enabled = isNullOrUndefined(this.props.enabled) ? true : this.props.enabled;

        if (!enabled)
            return null;

        if (this.props.permanent === true)
            return <React.Fragment>{this.renderButtons(false)}</React.Fragment>

        return (
            <React.Fragment>
                {' '}<span style={{ whiteSpace: "nowrap" }} className="print-hidden">(
                <a onMouseDown={(e) => { ReactTooltip.hide(); e.stopPropagation(); }} onMouseUp={(e) => e.stopPropagation()}
                        className={`link-functional ${this.props.activeLanguage.code.startsWith('de') ? '' : 'lowercase'}`}
                        data-tip data-event='click focus' data-for={this.getTooltipId(this.props.id)}
                        ref={ref => this.linkRef = ref}
                    >
                        <Translate id='Common.Map' />
                    </a>
                )</span>{' '}
                {this.state.renderTooltip &&
                    <ReactTooltip
                        globalEventOff='mousedown'
                        clickable={true}
                        effect='solid'
                        className='map-tooltip'
                        border={true}
                        id={this.getTooltipId(this.props.id)}
                        overridePosition={this.overrideTooltipPosition}
                    >
                        {this.renderButtons(true)}
                    </ReactTooltip>
                }
            </React.Fragment>
        )
    }

    renderButtons = (center) => {
        return (
            <div
                className={`map-links-wrapper${center ? ' center' : ''}`}
                onMouseDown={(e) => { ReactTooltip.hide(this.linkRef); e.stopPropagation(); }} onMouseUp={(e) => e.stopPropagation()}
            >
                <div className='map-link google-map-link'>
                    <a title="Google Maps" target="_blank" href={this.googleMapsLink()}>
                        <img src={GoogleLogo} alt='' />
                    </a>
                </div>
                <div className='map-link mapy-cz-link'>
                    <a title="Mapy.cz" target="_blank" href={this.mapyCzLink()}>
                        <img src={MapyCzLogo} alt='' />
                    </a>
                </div>                
            </div>
        )
    }

    googleMapsLink = () => {
        var domain;
        switch (this.props.activeLanguage.code) {
            case "sk-SK": domain = "sk";
                break;
            case "cs-CZ": domain = "cz";
                break;
            case "de-DE": domain = "de";
                break;
            default: domain = "com";
                break;
        }

        // map url guidelines: https://developers.google.com/maps/documentation/urls/guide
        return "https://www.google." + domain + "/maps/search/?api=1&query=" + encodeURIComponent(this.props.address).replace(/%20/g, '+');
    }

    mapyCzLink = () => {
        return "https://mapy.cz/zakladni?q=\"" + encodeURIComponent(this.mapyCzAddressFix(this.props.address)) + "\"";
    }

    mapyCzAddressFix = (address) => {
        var unknownSubstrings = ["mestská časť", "městská část"];
        
        var re = new RegExp(unknownSubstrings.join("|"), "g");
        return address.replace(re, '');
    }

    getTooltipId = id => `map-tooltip-for-entity-` + ((id || id === 0) ? id : 'without-id');

    overrideTooltipPosition = ({ top, left }, _0, _1, _2, place) => {
        switch (place) {
            case 'top': return { top: top + 7, left };
            case 'bottom': return { top: top - 7, left };
            case 'left': return { top, left: left + 3 };
            case 'right': return { top, left: left - 3 };
            default: return { top, left };
        }
    }
}

export default withLocalize(Map);

